import React, { useState } from "react";
import "./style.css";
import { useConfirm } from "../../../context/ConfirmContext";

import "@fortawesome/fontawesome-free/css/all.min.css";

import icone from "../../../assets/perfilMobileIcone.webp";

const PerfilMobile = () => {
    const fullName = localStorage.getItem("fullName") || "";

    const { showConfirm } = useConfirm(); // Use o hook useConfirm

    const handleLogout = () => {
        showConfirm(
            "Deseja realmente sair do sistema?",
            () => {
                localStorage.clear();
                window.location.href = "/login";
            },
            () => {}
        );
    };

    return (
        <div className="perfilMobile-tela">
            <div className="perfilMobile-container">
                <div id="perfilMobile-imagem">
                    <img src={icone} alt="perfil"></img>
                </div>
                <div id="perfilMobile-nome">
                    <h2>{fullName}</h2>
                </div>
                <div id="perfilMobile-logout">
                    <button onClick={handleLogout}>Logout</button>
                </div>
            </div>
        </div>
    );
};

export default PerfilMobile;
